const DEFAULT_ICONS_PATH = 'assets/icons';
const REBRAND_ICONS_PATH = 'assets/icons/rebrand';

const ICON_LINKS_SELECTOR = 'link[rel~="icon"], link[rel="apple-touch-icon"]';

const DEFAULT_ICON_LINKS: Record<string, string>[] = [
  { rel: 'shortcut icon', href: './favicon.ico' },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '32x32',
    href: `${DEFAULT_ICONS_PATH}/favicon-32x32.png`,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '16x16',
    href: `${DEFAULT_ICONS_PATH}/favicon-16x16.png`,
  },
  {
    rel: 'apple-touch-icon',
    sizes: '180x180',
    href: `${DEFAULT_ICONS_PATH}/apple-touch-icon.png`,
  },
];

const REBRAND_ICON_LINKS: Record<string, string>[] = [
  { rel: 'icon', type: 'image/svg+xml', href: `${REBRAND_ICONS_PATH}/favicon.svg` },
  { rel: 'shortcut icon', href: `${REBRAND_ICONS_PATH}/favicon.ico` },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '32x32',
    href: `${REBRAND_ICONS_PATH}/favicon-32x32.png`,
  },
  {
    rel: 'icon',
    type: 'image/png',
    sizes: '16x16',
    href: `${REBRAND_ICONS_PATH}/favicon-16x16.png`,
  },
  {
    rel: 'apple-touch-icon',
    sizes: '180x180',
    href: `${REBRAND_ICONS_PATH}/apple-touch-icon.png`,
  },
];

const createIconLink = (attributes: Record<string, string>): HTMLLinkElement => {
  const link = document.createElement('link');

  Object.entries(attributes).forEach(([name, value]) => link.setAttribute(name, value));

  return link;
};

const replaceIconLinks = (iconLinks: Record<string, string>[]): void => {
  const currentHrefs = Array.from(document.querySelectorAll(ICON_LINKS_SELECTOR)).map((link) =>
    link.getAttribute('href'),
  );
  const wantedHrefs = iconLinks.map((attributes) => attributes.href);
  const alreadyApplied = wantedHrefs.every((href) => currentHrefs.includes(href));

  if (alreadyApplied) {
    return;
  }

  document.querySelectorAll(ICON_LINKS_SELECTOR).forEach((link) => link.remove());

  iconLinks.forEach((attributes) => document.head.appendChild(createIconLink(attributes)));
};

export const applyRebrandFavicons = (): void => replaceIconLinks(REBRAND_ICON_LINKS);

export const applyDefaultFavicons = (): void => replaceIconLinks(DEFAULT_ICON_LINKS);
